@if (kundorder) {
<rask-page [pageTitle]="pageTitle">
    <ng-container headerContent>
        <rask-copy-order-header [orderHeader]="header" [kundorder]="kundorder" [rootForm]="rootForm"
            [validationContext]="validationContext"></rask-copy-order-header>
    </ng-container>
    <rask-toggle-list>
        <ng-container list-header>
            <rask-label size="2">Terminal *</rask-label>
            <rask-label>Avlastningsplats</rask-label>
            <rask-label size="2">Handelssortiment *</rask-label>
            <rask-label style="width:160px;max-width:none;">Avtalskvantitet *</rask-label>
            <rask-label style="width:160px;max-width:none;">Från och med *</rask-label>
            <rask-label style="width:160px;max-width:none;">Till och med *</rask-label>
            <rask-label>Kopiera</rask-label>
        </ng-container>
        @for (kundorderrad of kundorder?.kundorderrader; track kundorderrad) {
        <rask-toggle-list-item>
            <ng-container item-header>
                <rask-kundorderrad-edit
                    [kundorderTyp]="kundorderTyp"
                    [kundorder]="kundorder"
                    [mattslag]="kundorder.mattslag"
                    [rootForm]="rootForm"
                    [showLabels]="false"
                    [kundorderrad]="kundorderrad"
                    [isCopy]="true">
                </rask-kundorderrad-edit>
            </ng-container>
        </rask-toggle-list-item>
        }
    </rask-toggle-list>
    <ng-container footerContent>
        <rask-save-button [disabled]="!canSave()" (click)="save()"></rask-save-button>
    </ng-container>
</rask-page>
}